import { Alert } from '@mantine/core';
import { IconTool } from '@tabler/icons-react';
import { memo, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { EntryHeader } from '../../components/Organisms';
import { ApplicationState } from '../../store';

interface LandingLayoutProps extends PropsWithChildren {}

const BACKGROUND_STYLE = {
    backgroundImage: 'var(--landing-gradient)',
} as const;

const FORM_CONTAINER_STYLE = {
    background: 'var(--surface-1)',
    borderWidth: '0.5px',
    borderColor: 'var(--line)',
} as const;

function LandingLayout({ children }: LandingLayoutProps) {
    const { t } = useTranslation('notifications');
    const maintenance = useSelector((state: ApplicationState) => state.maintenance.active);

    return (
        <>
            <EntryHeader />
            <div
                className="relative w-full h-dvh sm:h-[calc(100dvh-4.5rem)] overflow-hidden"
                style={BACKGROUND_STYLE}
            >
                <div className="h-full flex flex-col justify-center items-center gap-4">
                    <div className="inline-flex flex-col items-center text-center">
                        <span className="text-3xl/12 font-bold text-fg text-center">
                            Think it. Build it.
                        </span>
                        <span className="text-base text-fg/78">The Cloud for fast solvers.</span>
                    </div>
                    {maintenance && (
                        <Alert
                            color="var(--color-status-warning)"
                            variant="light"
                            icon={<IconTool size={18} />}
                            title={t('maintenance.bannerTitle')}
                            className="w-83.5"
                        >
                            {t('maintenance.bannerMessage')}
                        </Alert>
                    )}
                    <div className="w-83.5 p-4 rounded-[10px]" style={FORM_CONTAINER_STYLE}>
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
}

export default memo(LandingLayout);
